import Card from "../visual-components/card";
import createElement from "../logical-components/createElement";
import internalEvents from "../logical-components/internalEvents";
import buildSearchParam from "../core/utils/buildSearchParams";
import renderText from "../logical-components/renderText";
import rememberMe from "./rememberMe";
import svgs from "../visual-components/svgs";
// utils for custom view
import generatePapers from "../visual-components/card-papers";
import generateImage from "../visual-components/card-image";
import generateMeta from "../visual-components/card-meta";
// Pagination
import renderPagination from "../visual-components/pagination";
import renderLoadMore from "../visual-components/renderLoadMore";
import "./scss/feed.scss";
// Demo content
import dataLayer from "../logical-components/dataLayer";
// Simple feed section
var feed = function (_a) {
    var _b, _c, _d;
    var config = _a.config, section = _a.section;
    var state = {
        currentPage: 1,
        searchParams: [],
    };
    var wrapperClass = (_c = (_b = section.classNames) === null || _b === void 0 ? void 0 : _b.feedWrapper) !== null && _c !== void 0 ? _c : '_mnslq-feed-wrapper';
    var wrapper = createElement('div', [
        { type: 'class', value: wrapperClass },
    ]);
    var events = internalEvents(config);
    // generic render method
    var render = function (persons, totalPersons, append) {
        var paginationElement = wrapper.querySelector('._msnlq-pagination-wrapper');
        if (append) {
            // Remove loader element if present
            var loaderElement = wrapper.querySelector('._mnslq-loader-wrapper');
            if (loaderElement) {
                wrapper.removeChild(loaderElement);
            }
        }
        else {
            // clean before add
            wrapper.innerHTML = '';
        }
        var numberOfCards = section.options.numOfCards || 12;
        persons === null || persons === void 0 ? void 0 : persons.forEach(function (person, index) {
            var _a, _b, _c, _d, _e;
            var pageIndex = state.currentPage - 1;
            var cardIndex = append ? (pageIndex * numberOfCards) + index : index;
            // Don't render passed the max amount
            if ((section.options.numOfCards &&
                index < section.options.numOfCards) ||
                !section.options.numOfCards) {
                //
                // Determine card to render / use
                var templateWrapper = document.createElement('div');
                templateWrapper.className = (_b = (_a = section.classNames) === null || _a === void 0 ? void 0 : _a.card) !== null && _b !== void 0 ? _b : '_mnslq-card';
                // Advertisement rendering
                var renderEveryNth = (_c = section === null || section === void 0 ? void 0 : section.options) === null || _c === void 0 ? void 0 : _c.renderAtInterval;
                var renderAd = (_d = section === null || section === void 0 ? void 0 : section.views) === null || _d === void 0 ? void 0 : _d.renderAtIntervals;
                if (renderEveryNth && renderAd && cardIndex > 0 && cardIndex % renderEveryNth === 0) {
                    var addElement = document.createElement('div');
                    if (append) {
                        wrapper.insertBefore(addElement, paginationElement);
                    }
                    else {
                        wrapper.append(addElement);
                    }
                    var renderAdResult = renderAd(addElement, cardIndex / renderEveryNth);
                    if (renderAdResult) {
                        addElement.innerHTML = renderAdResult;
                    }
                }
                var element_1 = null;
                if ((_e = section === null || section === void 0 ? void 0 : section.views) === null || _e === void 0 ? void 0 : _e.card) {
                    var ele = section.views.card({
                        data: person,
                        svgs: svgs,
                        renderText: renderText,
                        events: events,
                        wrapper: wrapper,
                        generatedPapers: generatePapers(person),
                        generatedImage: generateImage(person),
                        generatedMeta: generateMeta(config, section, {
                            meta: {
                                writes: person.condolence_count || 0,
                                candles: person.candle_count || 0,
                                flowers: person.flower_count || 0,
                            },
                        }),
                    });
                    if (typeof ele === 'string') {
                        templateWrapper.innerHTML = ele;
                    }
                    else {
                        templateWrapper.appendChild(ele);
                    }
                    element_1 = templateWrapper;
                }
                else {
                    element_1 = Card(config, section, person);
                }
                if (append) {
                    wrapper.insertBefore(element_1, paginationElement);
                }
                else {
                    wrapper.append(element_1);
                }
                var cardClick_1 = function (payload) {
                    var rememberMeSection = config.layout.filter(function (layout) { return layout === 'rememberMe'; })[0];
                    events.emit('openOverlay', rememberMe({
                        config: config,
                        data: payload.person,
                        section: rememberMeSection || {},
                    }));
                };
                // const baseUrl = section?.options?.baseUrl
                element_1.addEventListener('click', function (event) {
                    var _a;
                    // Override url
                    if (person.url) {
                        window.open(person.url, '_blank').focus();
                        return;
                    }
                    if (section.hooks.onClick) {
                        section.hooks.onClick({
                            element: element_1,
                            person: person,
                            wrapper: wrapper,
                            event: event,
                            events: events,
                            callback: cardClick_1,
                        });
                    }
                    if ((_a = section.options) === null || _a === void 0 ? void 0 : _a.detailPage) {
                        location.href = section.options.detailPage.replace('{id}', person.slug);
                    }
                });
            }
        });
        // Only render pagination once
        if (!paginationElement) {
            paginationElement = renderFooter(numberOfCards, totalPersons);
        }
        var numCards = wrapper.querySelectorAll('._mnslq-card').length;
        var hasMore = numCards < totalPersons;
        paginationElement === null || paginationElement === void 0 ? void 0 : paginationElement.classList.toggle('_mnslq-all-loaded', !hasMore);
    };
    var renderLoader = function (append) {
        var paginationElement = wrapper.querySelector('._msnlq-pagination-wrapper');
        if (!append) {
            // Reset DOM
            wrapper.innerHTML = "<div class=\"_mnslq-loader-wrapper\">\n                <span class=\"_mnslq-loader\"></span>\n            </div>";
        }
        else {
            var loaderElement = document.createElement('div');
            loaderElement.className = '_mnslq-loader-wrapper';
            loaderElement.innerHTML = "<span class=\"_mnslq-loader\"></span>";
            wrapper.insertBefore(loaderElement, paginationElement);
        }
    };
    var renderFooter = function (numberOfCards, totalPersons) {
        // Render pagination
        var _a = section.options, loadMore = _a.loadMore, loadMoreAutomatic = _a.loadMoreAutomatic, pagination = _a.pagination;
        if (totalPersons > 0 &&
            totalPersons / numberOfCards > 1) {
            var totalPages = Math.ceil(totalPersons / numberOfCards);
            var meta = {
                current_page: state.currentPage,
                last_page: totalPages
            };
            if (loadMore) {
                var loadMoreEl = renderLoadMore({
                    section: section,
                    meta: meta,
                    wrapper: wrapper,
                    loadMoreAutomatic: loadMoreAutomatic,
                    loadMore: function () {
                        state.currentPage++;
                        // show loader
                        renderLoader(true);
                        // Request new render
                        dataLayer(config, section, state.searchParams, state.currentPage).then(function (data) {
                            render(data.persons, data.count, true);
                        });
                    },
                });
                wrapper.appendChild(loadMoreEl);
                return loadMoreEl;
            }
            else if (pagination === undefined || pagination) {
                var paginationElement = renderPagination({
                    meta: meta,
                    changePage: function (page) {
                        state.currentPage = page;
                        // show loader
                        renderLoader();
                        // Request new render
                        dataLayer(config, section, state.searchParams, state.currentPage).then(function (data) {
                            render(data.persons, data.count);
                        });
                    },
                });
                wrapper.appendChild(paginationElement);
                return paginationElement;
            }
        }
    };
    // Render initial data
    renderLoader();
    var urlParams = new URLSearchParams(window.location.search);
    var searchString = urlParams.get('search');
    var initSearch = searchString ? [{ key: 'search', value: searchString }] : null;
    dataLayer(config, section, initSearch).then(function (data) {
        render(data.persons, data.count);
    });
    // React to searches
    events.on('search', function (searchQueries) {
        // Feed only sections do not respond to events
        if (section.options.feedOnly) {
            return;
        }
        // show loader
        renderLoader();
        // map data to parameters
        state.searchParams = buildSearchParam(searchQueries);
        // Perform search
        dataLayer(config, section, state.searchParams).then(function (data) {
            render(data.persons, data.count);
        });
    });
    if ((_d = section === null || section === void 0 ? void 0 : section.options) === null || _d === void 0 ? void 0 : _d.respondToGlobalSearch) {
        window._mensenlinqEvents.on('search', function (_a) {
            var payload = _a.payload;
            // show loader
            renderLoader();
            state.searchParams = buildSearchParam(payload);
            // Perform search
            dataLayer(config, section, state.searchParams, 1).then(function (data) {
                render(data.persons, data.count);
            });
        });
    }
    return wrapper;
};
export default feed;
